module.exports = __webpack_public_path__ + "static/img/icon_wepay.0d2d5a8a.png";